export default "__VITE_ASSET__DQq9u6FP__"